<a
    href="https://www.linkedin.com/company/genesys"
    target="_blank"
    aria-label="Visit us on LinkedIn"
    matTooltip="Visit us on LinkedIn"
    [matTooltipShowDelay]="1000"
    [matTooltipHideDelay]="2000"
    data-testId="linkedin">
    <div class="icon-wrapper">
        <mat-icon [svgIcon]="'linkedin'" color="primary" aria-hidden></mat-icon>
    </div>
</a>
<a
    href="https://www.instagram.com/genesyscx"
    target="_blank"
    aria-label="Visit us on Instagram"
    matTooltip="Visit us on Instagram"
    [matTooltipShowDelay]="1000"
    [matTooltipHideDelay]="2000"
    data-testId="instagram">
    <div class="icon-wrapper">
        <mat-icon [svgIcon]="'instagram'" color="primary" aria-hidden></mat-icon>
    </div>
</a>
<a
    href="https://x.com/Genesys"
    target="_blank"
    aria-label="Visit us on X"
    matTooltip="Visit us on X"
    [matTooltipShowDelay]="1000"
    [matTooltipHideDelay]="2000"
    data-testId="twitter_x">
    <div class="icon-wrapper">
        <mat-icon [svgIcon]="'twitter_x'" color="primary" aria-hidden></mat-icon>
    </div>
</a>
<a
    href="https://www.facebook.com/Genesys"
    target="_blank"
    aria-label="Visit us on Facebook"
    matTooltip="Visit us on Facebook"
    [matTooltipShowDelay]="1000"
    [matTooltipHideDelay]="2000"
    data-testId="facebook">
    <div class="icon-wrapper">
        <mat-icon [svgIcon]="'facebook'" color="primary" aria-hidden></mat-icon>
    </div>
</a>
<a
    href="https://www.youtube.com/Genesys"
    target="_blank"
    aria-label="Visit us on YouTube"
    matTooltip="Visit us on YouTube"
    [matTooltipShowDelay]="1000"
    [matTooltipHideDelay]="2000"
    data-testId="youtube">
    <div class="icon-wrapper">
        <mat-icon [svgIcon]="'youtube'" color="primary" aria-hidden></mat-icon>
    </div>
</a>
<a
    href="https://www.genesys.com/blog"
    target="_blank"
    aria-label="Visit the Genesys Blog"
    matTooltip="Visit the Genesys Blog"
    [matTooltipShowDelay]="1000"
    [matTooltipHideDelay]="2000"
    data-testId="blog">
    <div class="icon-wrapper">
        <mat-icon [svgIcon]="'wordpress'" color="primary" aria-hidden></mat-icon>
    </div>
</a>
